module.exports = __webpack_public_path__ + "static/Graphik-Regular-Web-9c8711499627177440d1bb4e49946533.woff2";